import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

class MeetingUserImage extends React.Component {

  constructor(props) {
    super(props)

    this.imageSource = this.imageSource.bind(this)
  }

  imageSource() {
    const src = this.props.otherUser.avatar_url
    if(src === 'medium/missing.png' || src == undefined) {
      return (
        <img
          className="missingImg upcomingLexCard__avatar"
          alt=""
        />)
    }
    return (
      <img
        src={src}
        className="upcomingLexCard__avatar"
        alt=""
      />)
  }

  render() {
    return(
      <button
        type="button"
        className="upcomingLexCard__avatarBtn"
        onClick={() => window.location.assign(`/profile/${this.props.otherUser.slug}`)}
      >
        {this.imageSource()}
      </button>
    )
  }
}

export default MeetingUserImage;
